import React from 'react';

const SearchIconRegular: React.FC<{ width: number, height: number}> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 25 25" fill="none">
    <path d="M17.75 9.75C17.75 7.07812 16.2969 4.64062 14 3.28125C11.6562 1.92188 8.79688 1.92188 6.5 3.28125C4.15625 4.64062 2.75 7.07812 2.75 9.75C2.75 12.4688 4.15625 14.9062 6.5 16.2656C8.79688 17.625 11.6562 17.625 14 16.2656C16.2969 14.9062 17.75 12.4688 17.75 9.75ZM16.2969 17.4375C14.6094 18.75 12.5 19.5 10.25 19.5C4.85938 19.5 0.5 15.1406 0.5 9.75C0.5 4.40625 4.85938 0 10.25 0C15.5938 0 20 4.40625 20 9.75C20 12.0469 19.2031 14.1562 17.8906 15.8438L24.1719 22.0781C24.5938 22.5469 24.5938 23.25 24.1719 23.6719C23.7031 24.1406 23 24.1406 22.5781 23.6719L16.2969 17.4375Z" fill="#111111"/>
  </svg>
);

export default SearchIconRegular;
